module.exports = __webpack_public_path__ + "img/horizontal_7_6_8003.149b67e9.png";